import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const formatNumber = (value, maximumFractionDigits = 0) => {
  if (value === null || value === undefined || value === "") return "-";
  const number = Number(value);
  return Number.isNaN(number)
    ? value
    : number.toLocaleString(undefined, { maximumFractionDigits });
};

const formatCurrency = (value) => {
  const formatted = formatNumber(value, 2);
  return formatted === "-" ? formatted : `£${formatted}`;
};

const formatLabel = (value) => String(value || "")
  .replace(/_/g, " ")
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const SummaryCard = ({ icon, label, value, subtitle, color, backgroundColor }) => (
  <Col sm={6} xl={3} className="mb-3">
    <Card className="h-100 mb-0" style={{ borderLeft: `4px solid ${color}` }}>
      <CardBody className="d-flex align-items-center" style={{ padding: "14px 16px" }}>
        <div
          className="d-flex align-items-center justify-content-center mr-3"
          style={{ width: 42, height: 42, flex: "0 0 42px", color, backgroundColor, borderRadius: "50%" }}
        >
          <i className={`fa ${icon}`} style={{ fontSize: 18 }} />
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="text-muted" style={{ fontSize: 11, fontWeight: 600 }}>{label}</div>
          <div className="font-weight-bold" style={{ fontSize: 20, lineHeight: 1.25 }}>{value}</div>
          {subtitle && <div className="text-muted" style={{ fontSize: 10 }}>{subtitle}</div>}
        </div>
      </CardBody>
    </Card>
  </Col>
);

const PriceReductionSummaryCards = ({ summary }) => {
  if (!summary) return null;

  const discountRange = summary.recommended_discount_range;

  return (
    <Row className="mt-3" style={{ marginRight: "-7.5px", marginLeft: "-7.5px" }}>
      <SummaryCard
        icon="fa-cubes"
        label="Total Units in Stock"
        value={formatNumber(summary.total_units_in_stock)}
        color="#2457a7"
        backgroundColor="#e8f1ff"
      />
      <SummaryCard
        icon="fa-gbp"
        label="Current Stock Value"
        value={formatCurrency(summary.current_stock_value)}
        subtitle={summary.stock_value_basis
          ? `Based on ${formatLabel(summary.stock_value_basis)}`
          : null}
        color="#247a47"
        backgroundColor="#e9f7ef"
      />
      <SummaryCard
        icon="fa-line-chart"
        label="Current Average Selling Price"
        value={formatCurrency(summary.current_average_selling_price)}
        color="#6f42c1"
        backgroundColor="#f2ecfb"
      />
      <SummaryCard
        icon="fa-percent"
        label="Recommended Discount Range"
        value={discountRange
          ? `${formatNumber(discountRange.min, 2)}% – ${formatNumber(discountRange.max, 2)}%`
          : "-"}
        color="#e66a00"
        backgroundColor="#fff1e6"
      />
    </Row>
  );
};

export default PriceReductionSummaryCards;
